import { render, staticRenderFns } from "./CotizacionesList.vue?vue&type=template&id=58a99762&"
import script from "./CotizacionesList.vue?vue&type=script&lang=js&"
export * from "./CotizacionesList.vue?vue&type=script&lang=js&"
import style0 from "./CotizacionesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports